import { PurchaseOrderOrderTypeEnum } from "./order-type-enum";

export const orderTypeLabels = {
  [PurchaseOrderOrderTypeEnum.STANDARD]: "Bulk",
  [PurchaseOrderOrderTypeEnum.LAB]: "Lab",
};
